import React from "react";
import { Col, Container, Row } from "react-bootstrap";

const UserFormSide = ({ pageTitle, }) => {
  return (
    <>
      <section className="userform_left">
        <Container>
          <Row>
            <Col md={12}>
              <div className="section-heading">
                <h2>{pageTitle}</h2>
                <h4>Welcome to Support assistant</h4>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default UserFormSide;
